import { z } from 'zod';
import { expectType, zDocument } from './model.js';
import { reverseKeys } from './util/reverseKeys.js';
export const AffinityInteractionLookup = {
    likedComment: 'Liked Comment',
    dislikedComment: 'Disliked Comment',
    likedPost: 'Liked Post',
    dislikedPost: 'Disliked Post',
    reportedPost: 'Reported Post',
    unreportedPost: 'Unreported Post',
    reportedComment: 'Reported Comment',
    unreportedComment: 'Reported Comment',
    reportedMessage: 'Reported Message',
    unreportedMessage: 'Unreported Message'
};
export const AffinityInteractionEnum = z.nativeEnum(reverseKeys(AffinityInteractionLookup));
export const zAffinity = zDocument.extend({
    type: z.literal('affinity'),
    user: z.string(),
    otherUser: z.string(),
    affinity: z.number()
});
expectType({});
expectType({});
export const EmptyAffinity = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    type: 'affinity',
    user: '',
    otherUser: '',
    affinity: 0
};
